// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicFileActions } from "./plasmic/blank_project/PlasmicFileActions";

function FileActions_(props, ref) {

  return <PlasmicFileActions root={{ ref }} {...props} />;
}

const FileActions = React.forwardRef(FileActions_);

export default FileActions;
